import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from '../authProvider/AuthContext';
import PrimaryButton from '../common/button/PrimaryButton';
import SecondaryButton from '../common/button/SecondaryButton';

function Header() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('home');

  const redirectToDashboard = () => {
    if (isLoggedIn()) {
      navigate('/dashboard');
    }
  };

  const handleLogin = () => {
    navigate('/login');
  }

  const handleContact = () =>{
    window.open('https://www.buyculsloans.com/contact-us/', '_blank', 'noopener,noreferrer');
  }

  const handleNavClick = (section) => {
    setActiveTab(section);
    if (section === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="px-8">
      <div style={{ backgroundColor: "#F6FEF9" }} className="pb-4 rounded-t-xl flex justify-between">
        <div className="flex items-center cursor-pointer pl-6 pt-4" onClick={redirectToDashboard}>
          <div className="h-12 w-12 rounded-full flex items-center justify-center">
            <img className="rounded-full max-w-none" src="/logo.png" alt="Dashboard visual" style={{ width: "60px", height: "60px" }}/>
          </div>
          <div className="text-xl font-bold ml-2">DMV Navigator</div>
        </div>

        <div className="flex flex-row items-center justify-between space-x-6 pr-6 pt-4">
          <button
            className={`text-lg font-medium ${
              activeTab === 'home' ? 'text-green-800 border-b-2 border-green-800' : 'text-gray-800 hover:text-green-800'
            }`}
            onClick={() => handleNavClick('home')}
          >
            Home
          </button>
          <button
            className={`text-lg font-medium ${
              activeTab === 'about' ? 'text-green-800 border-b-2 border-green-800' : 'text-gray-800 hover:text-green-800'
            }`}
            onClick={() => handleNavClick('about')}
          >
            About
          </button>
          <button onClick={handleContact} className="text-lg font-medium text-gray-800 hover:text-green-800">
            Contact Us
          </button>
        </div>

        <div className="flex flex-row gap-4 items-center mt-2 mr-8">
          <SecondaryButton
            text="Login"
            onClick={handleLogin}
          />
          <PrimaryButton
            text="Get Started"
            onClick={() => window.open('https://culoansource.formstack.com/forms/lendingsolutions_interest', '_blank', 'noopener,noreferrer')}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;